import React, { useEffect, useState } from 'react'
import { Box, Button, Flex, Group, SimpleGrid, Text, Combobox, useCombobox, Input, InputBase, Loader, Image, Paper, ScrollArea, CloseButton } from '@mantine/core'
import { useDebouncedCallback } from '@mantine/hooks'
import { updateBrand } from '../../../services/brands'
import { notificationError, notificationSuccess } from '../../ui/Notifications'
import { getCategorysList, getDetailCategory } from '../../../services/category'
import LoadingData from '../../ui/LoadingData'
import NoImage from '../../../assets/img/images/no-images.png'

const FormCategories = ({ dataBrand, onCloseModal, reloadList }) => {
  const [brandId, setBrandId] = useState(null)

  const [categoryLvl1, setCategoryLvl1] = useState(null)
  const [categoryLvl2, setCategoryLvl2] = useState(null)
  const [categoryLvl3, setCategoryLvl3] = useState(null)

  const [categoryLvl1List, setCategoryLvl1List] = useState([])
  const [categoryLvl2List, setCategoryLvl2List] = useState([])
  const [categoryLvl3List, setCategoryLvl3List] = useState([])
  
  const [loadingCategory, setLoadingCategory] = useState(false)
  const [loadingCategoryLvl1, setLoadingCategoryLvl1] = useState(false)
  const [loadingCategoryLvl2, setLoadingCategoryLvl2] = useState(false)
  const [loadingCategoryLvl3, setLoadingCategoryLvl3] = useState(false)
  const [loadingForm, setLoadingForm] = useState(false)

  const formCategoryLvl1 = useCombobox({
    onDropdownClose: () => formCategoryLvl1.resetSelectedOption(),
    onDropdownOpen: () => {
      if (categoryLvl1List.length === 0 && !loadingCategoryLvl1) {
        getCategoriesLvl1()
        formCategoryLvl1.resetSelectedOption()
      }
    },
  })

  const formCategoryLvl2 = useCombobox({
    onDropdownClose: () => formCategoryLvl2.resetSelectedOption(),
    onDropdownOpen: () => {
      if (categoryLvl1List.length === 0 && !loadingCategoryLvl2) {
        getCategoriesLvl2()
        formCategoryLvl2.resetSelectedOption()
      }
    },
  })
  const formCategoryLvl3 = useCombobox({
    onDropdownClose: () => formCategoryLvl3.resetSelectedOption(),
    onDropdownOpen: () => {
      if (categoryLvl1List.length === 0 && !loadingCategoryLvl3) {
        getCategoriesLvl3()
        formCategoryLvl3.resetSelectedOption()
      }
    },
  })

  const getCurrentCategory = async (categoryId) => {
    setLoadingCategory(true)
    const parameter = {
      'include': 'parent',
      'fields[category]': 'name,image,level',
    }
    try {
      const response = await getDetailCategory(categoryId, parameter)
      if (response.success) {
        const { data, included } = response
        const { attributes } = data
        const { parent } = included

        const setResult = (_category) => {
          return {
            value: `${_category.id}`,
            label: _category.name,
            image: _category.image
          }
        }
        
        let lvl1 = null
        let lvl2 = null
        let lvl3 = null

        if (attributes.level === 1) {
          lvl1 = setResult(attributes)
        } else if (attributes.level === 2) {
          lvl2 = setResult(attributes)
        } else {
          lvl3 = setResult(attributes)
        }
        
        if (attributes.level !== 1) {
          const remapArrParents = Object.values(parent).map((e) => e.attributes)
          const _categoryLvl1 = remapArrParents.find(e => e.level === 1)
          const _categoryLvl2 = remapArrParents.find(e => e.level === 2)

          if (_categoryLvl2) {
            lvl2 = setResult(_categoryLvl2)
          }
          lvl1 = setResult(_categoryLvl1)
        }

        setCategoryLvl1(lvl1)
        setCategoryLvl2(lvl2)
        setCategoryLvl3(lvl3)
      }
      

    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategory(false)
    }
  }

  const getCategoriesLvl1 = useDebouncedCallback(async () => {
    setLoadingCategoryLvl1(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[level][is]': 1,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl1List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl1(false)
    }
  }, 300)

  const getCategoriesLvl2 = useDebouncedCallback(async (categoryIdLvl1) => {
    setLoadingCategoryLvl2(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[parent_id][is]': categoryIdLvl1,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl2List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl2(false)
    }
  }, 300)

  const getCategoriesLvl3 = useDebouncedCallback(async (categoryIdLvl2) => {
    setLoadingCategoryLvl3(true)
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[parent_id][is]': categoryIdLvl2,
      'fields[category]': 'name,image',
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategories = response.data.data
      const remapDataCategories = dataCategories.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name,
          image: val.attributes.image,
        }
      })
      setCategoryLvl3List(remapDataCategories)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCategoryLvl3(false)
    }
  }, 300)

  useEffect(() => {
    if (dataBrand) {
      setBrandId(dataBrand.id)

      if(dataBrand.categories) {
        getCurrentCategory(dataBrand.categories.id)
      }
    }

    getCategoriesLvl1()
    // eslint-disable-next-line
  }, [dataBrand])

  useEffect(() => {
    if (categoryLvl1) {
      getCategoriesLvl2(categoryLvl1.value)
    }
    // eslint-disable-next-line
  }, [categoryLvl1])

  useEffect(() => {
    if (categoryLvl2) {
      getCategoriesLvl3(categoryLvl2.value)
    }
    // eslint-disable-next-line
  }, [categoryLvl2])

  const submitCategory = async () => {
    setLoadingForm(true)
    const payload = {
      category_id: categoryLvl3 !== null ? Number(categoryLvl3.value) : null || 
      categoryLvl2 !== null ? Number(categoryLvl2.value) : null || 
      categoryLvl1 !== null ? Number(categoryLvl1.value) : null || null,
    }

    let titleMessageSuccess = 'Set Category Successfully'
    let captionMessageSuccess = 'You have been set data Category'
    let titleMessageError = 'Set Category Error'
    let captionMessageError = ''
    
    try {
      const response = await updateBrand(brandId, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Error'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }

  }

  const renderCategoryOptionList = (data, dataCategory) => {
    if (data !== null ) {
      if (data.length > 0) {
        const remapData = data.map((val, index) => {
          return (
            <Combobox.Option value={val} key={index} active={val === dataCategory}>
              <Group flex="1" align='center' gap="xs">
                <Flex gap='sm' align='center'>
                  <Paper shadow="sm" w={32} withBorder radius='md'>
                    <Image w={30} h={30} radius='md' src={val.image !== null ? val.image : NoImage} />
                  </Paper>
                  <Box>
                    <Text fz={12} lineClamp={2} fw='500'>{val.label}</Text>
                  </Box>
                </Flex>
              </Group>
            </Combobox.Option>
          )
        })
        return remapData
      } else {
        return (
          <Combobox.Empty>No Data Category Found</Combobox.Empty>
        )
      }
    }
  }

  const renderValueCategory = (dataCategory) => {
    if (dataCategory !== null) {
      return (
        <Group flex="1" align='center' gap="xs">
          <Flex gap='sm' align='center'>
            <Paper shadow="sm" w={32} withBorder radius='md'>
              <Image w={30} h={30} radius='md' src={dataCategory.image !== null ? dataCategory.image : NoImage} />
            </Paper>
            <Box>
              <Text fz={12} lineClamp={2}>{dataCategory.label}</Text>
            </Box>
          </Flex>
        </Group>
      )
    } 
  }

  const mappingFormCategory = () => {
    return (
      <SimpleGrid cols={3} verticalSpacing="md" spacing="md">
        <Box>
          <Input.Wrapper my={10} label='Category Level 1' size='xs'>
          <Combobox
            my={6}
            store={formCategoryLvl1}
            onOptionSubmit={(val) => {
              setCategoryLvl1(val)
              formCategoryLvl1.closeDropdown()
            }}
            position='bottom'
          >
            <Combobox.Target>
              <InputBase
                component="button"
                type="button"
                pointer
                rightSection={
                  loadingCategoryLvl1 ? <Loader size={18} /> : 
                  categoryLvl1 !== null ? 
                  <CloseButton size="sm" onMouseDown={(event) => event.preventDefault()} onClick={() => [setCategoryLvl1(null), setCategoryLvl2(null), setCategoryLvl3(null)]} /> :
                  <Combobox.Chevron />
                }
                onClick={() => formCategoryLvl1.toggleDropdown()}
                rightSectionPointerEvents={categoryLvl1 === null ? 'none' : 'all'}
                size='lg'
              >
                {categoryLvl1 !== null ? renderValueCategory(categoryLvl1) : <Input.Placeholder>Select Category</Input.Placeholder>}
              </InputBase>
            </Combobox.Target>

            <Combobox.Dropdown hidden={false}>
              <Combobox.Options>
                <ScrollArea.Autosize mah={400} scrollbars="y" type="scroll" offsetScrollbars>
                  {loadingCategoryLvl1 ? <Combobox.Empty>Loading....</Combobox.Empty> : renderCategoryOptionList(categoryLvl1List, categoryLvl1)}
                </ScrollArea.Autosize>
              </Combobox.Options>
            </Combobox.Dropdown>
          </Combobox>
          </Input.Wrapper>
        </Box>
        <Box>
          <Input.Wrapper my={10} label='Category Level 2' size='xs'>
          <Combobox
            my={6}
            store={formCategoryLvl2}
            onOptionSubmit={(val) => {
              setCategoryLvl2(val)
              formCategoryLvl2.closeDropdown()
            }}
          >
            <Combobox.Target>
              <InputBase
                component="button"
                type="button"
                pointer
                rightSection={
                  loadingCategoryLvl2 ? <Loader size={18} /> : 
                  categoryLvl2 !== null ? 
                  <CloseButton size="sm" onMouseDown={(event) => event.preventDefault()} onClick={() => [setCategoryLvl2(null), setCategoryLvl3(null)]} /> :
                  <Combobox.Chevron />
                }
                onClick={() => formCategoryLvl2.toggleDropdown()}
                rightSectionPointerEvents={categoryLvl2 === null ? 'none' : 'all'}
                size='lg'
                disabled={categoryLvl1 === null}
              >
                {categoryLvl2 !== null ? renderValueCategory(categoryLvl2) : <Input.Placeholder>Select Category</Input.Placeholder>}
              </InputBase>
            </Combobox.Target>

            <Combobox.Dropdown>
              <Combobox.Options>
                <ScrollArea mah={400} scrollbars="y" type="scroll" offsetScrollbars>
                  {loadingCategoryLvl2 ? <Combobox.Empty>Loading....</Combobox.Empty> : renderCategoryOptionList(categoryLvl2List, categoryLvl2)}
                </ScrollArea>
              </Combobox.Options>
            </Combobox.Dropdown>
          </Combobox>
          </Input.Wrapper>
        </Box>
        <Box>
          <Input.Wrapper my={10} label='Category Level 3' size='xs'>
          <Combobox
            my={6}
            store={formCategoryLvl3}
            onOptionSubmit={(val) => {
              setCategoryLvl3(val)
              formCategoryLvl3.closeDropdown()
            }}
          >
            <Combobox.Target>
              <InputBase
                component="button"
                type="button"
                pointer
                rightSection={
                  loadingCategoryLvl3 ? <Loader size={18} /> : 
                  categoryLvl3 !== null ? 
                  <CloseButton size="sm" onMouseDown={(event) => event.preventDefault()} onClick={() => setCategoryLvl3(null)} /> :
                  <Combobox.Chevron />
                }
                onClick={() => formCategoryLvl3.toggleDropdown()}
                rightSectionPointerEvents={categoryLvl2 === null ? 'none' : 'all'}
                size='lg'
                disabled={categoryLvl1 === null || categoryLvl2 === null}
              >
                {categoryLvl3 !== null ? renderValueCategory(categoryLvl3) : <Input.Placeholder>Select Category</Input.Placeholder>}
              </InputBase>
            </Combobox.Target>

            <Combobox.Dropdown>
              <Combobox.Options>
                <ScrollArea mah={400} scrollbars="y" type="scroll" offsetScrollbars>
                  {loadingCategoryLvl3 ? <Combobox.Empty>Loading....</Combobox.Empty> : renderCategoryOptionList(categoryLvl3List, categoryLvl3)}
                </ScrollArea>
              </Combobox.Options>
            </Combobox.Dropdown>
          </Combobox>
          </Input.Wrapper>
        </Box>
      </SimpleGrid>
    )
  }

  return (
    <Box>
      {loadingCategory ? <LoadingData /> : mappingFormCategory()}
      <Box mt='xl'>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} disabled={!categoryLvl1} variant="filled" onClick={() => submitCategory()}>{dataBrand !== null ? 'Update' : 'Add'}</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormCategories